export default [
  {
    path: '/review/index',
    name: 'review构建成功页面',
    component: () => import('@/views/TheReview.vue'),
    alias: ['/kids/review'],
  },
  {
    name: '学习报告',
    path: '/kids/learning-report',
    component: () => import('@/views/kids/learning-report/LearningReport.vue'),
    alias: ['/kids/wechat-official/learning-report'],
  },
  {
    name: '兑换中心',
    path: '/kids/redeem-center',
    component: () => import('@/views/kids/redeem-center/RedeemCenter.vue'),
  },
  {
    name: '激活会员',
    path: '/vip',
    component: () => import('@/views/kids/activate-vip/ActivateVip.vue'),
  },
];
